import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useBreakPoint } from '@repo/toolkit/use-break-point'
import { PropsWithChildren } from 'react'

import { InformationIcon } from '../../../icons'
import Popover from '../popover'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../tooltip'

const TOOLTIP_CLASSNAME =
  'mobile:max-w-xs h-full max-h-[28rem] overflow-y-auto p-2 bg-grey rounded-lg [&::-webkit-scrollbar-thumb]:bg-[#ffffff90]'

function DefaultTooltipTrigger() {
  return (
    <div className={'rounded-full bg-red-light w-5 h-5'}>
      <InformationIcon height={'20'} width={'20'} color={tailwindColors.secondary.DEFAULT} />
    </div>
  )
}

function DefaultTooltipContent({ children }: PropsWithChildren) {
  return <div className="flex items-start flex-col">{children}</div>
}

export function InputTooltip({ children }: PropsWithChildren) {
  const device = useBreakPoint()
  const isMobile = device === 'mobile'

  if (isMobile)
    return (
      <Popover triggerComponent={DefaultTooltipTrigger} className={TOOLTIP_CLASSNAME}>
        <DefaultTooltipContent>{children}</DefaultTooltipContent>
      </Popover>
    )

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger type={'button'}>
          <DefaultTooltipTrigger />
        </TooltipTrigger>
        <TooltipContent sideOffset={8} className={TOOLTIP_CLASSNAME}>
          <DefaultTooltipContent>{children}</DefaultTooltipContent>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
